module.exports = __webpack_public_path__ + "img/domestic_default.4494103.png";